export const isAnsweredQuiz = (quizId: string) => {
  let answeredQuizzes = []
  let json = localStorage.getItem('answeredQuizzes')
  if (json) {
    answeredQuizzes = JSON.parse(json)
  }
  return answeredQuizzes.includes(quizId);
}

export const saveAnsweredQuiz = (quizId: string) => {
  let answeredQuizzes = []
  let json = localStorage.getItem('answeredQuizzes')
  if (json) {
    answeredQuizzes = JSON.parse(json)
  }
  answeredQuizzes.push(quizId)
  localStorage.setItem('answeredQuizzes', JSON.stringify(answeredQuizzes))
}